import OrtForm from "./OrtForm";
import OrtMap from "./OrtMap";
import OrtTile from "./OrtTile";
import {useEffect, useRef, useState} from "react";
import OrtFilterRemoveButton from "./OrtFilterRemoveButton";

export default function OrtComponent() {
    const teaserColumnsRef = useRef(null);
    const mapRef = useRef(null);
    const hasUserInteractedRef = useRef(false);

    const [filters, setFilters] = useState(() => {
        const storedFilters = window.sessionStorage.getItem("baukulturFilters");

        if (storedFilters) {
            try {
                return JSON.parse(storedFilters);
            } catch (error) {
                // fall back to defaults if stored data is invalid
            }
        }

        return {
            types: [],
            usages: [],
            furtherFilters: [],
            years: []
        };
    });

    function updateFilters(nextFilters) {
        hasUserInteractedRef.current = true;
        setFilters(nextFilters);
    }

    useEffect(() => {
        window.sessionStorage.setItem("baukulturFilters", JSON.stringify(filters));
    }, [filters]);

    useEffect(() => {
        if (!hasUserInteractedRef.current) {
            return;
        }

        const mediaQuery = window.matchMedia("(min-width: 1480px)");
        const placeholder = document.querySelector(".baukultur-map__sticky-filters-placeholder");

        if (mediaQuery.matches && placeholder) {
            const rect = placeholder.getBoundingClientRect();

            if (rect.top < 0) {
                placeholder.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }
    }, [filters]);

    useEffect(() => {
        const inner = teaserColumnsRef.current;
        const map = mapRef.current;

        if (!map || !inner) return;

        function updateStickyState() {
            const mapRect = map.getBoundingClientRect();
            const mapBottom = mapRect.bottom;
            const teaserColumnsRect = inner.getBoundingClientRect();
            const teaserColumnsBottom = teaserColumnsRect.bottom;

            const nearTop = mapBottom <= 0;
            const reachedBottom = teaserColumnsBottom <= 0;

            document.body.classList.toggle("has-baukultur-map--fixed", nearTop && !reachedBottom);
        }

        window.addEventListener("scroll", updateStickyState, { passive: true });
        window.addEventListener("resize", updateStickyState);
        updateStickyState();

        return () => {
            window.removeEventListener("scroll", updateStickyState);
            window.removeEventListener("resize", updateStickyState);
        };
    }, []);

    const locations = window.baukulturMap.locations.filter(location =>
        (filters.types.length === 0 || location.ort_type.filter(value => filters.types.includes(value)).length > 0)
        && (filters.usages.length === 0 || location.ort_usage.filter(value => filters.usages.includes(value)).length > 0)
        && (filters.furtherFilters.length === 0 || location.ort_further_filter.filter(value => filters.furtherFilters.includes(value)).length > 0)
        && (filters.years.length === 0 || location.ort_year.filter(value => filters.years.includes(value)).length > 0)
    );

    let title;
    if (locations.length === 0) {
        title = 'Leider keine passenden Orte gefunden';
    }
    else if (locations.length === 1) {
        title = 'Ein Ort in Brandenburg';
    }
    else if (locations.length < window.baukulturMap.locations.length) {
        title = `${locations.length} Orte in Brandenburg`;
    } else {
        title = 'Alle Akteure und Orte in Brandenburg';
    }

    return <div className="baukultur-map">
        <div className="baukultur-map__fullwidth">
            <div ref={mapRef}>
                <OrtMap locations={locations} />
            </div>
            <div className="baukultur-map__sticky-filters-placeholder" />
            <OrtForm filters={filters} setFilters={updateFilters} />
        </div>
        <h3 className="font-h3 text-center">{title}</h3>
        <div className="baukultur-map__active-filters">
            {filters.types.map((item, index) => <OrtFilterRemoveButton item={item}
                                                                       group='types'
                                                                       filters={filters}
                                                                       setFilters={updateFilters} key={index}/>)}
            {filters.usages.map((item, index) => <OrtFilterRemoveButton item={item}
                                                                        group='usages'
                                                                        filters={filters}
                                                                        setFilters={updateFilters} key={index}/>)}
            {filters.furtherFilters.map((item, index) => <OrtFilterRemoveButton item={item}
                                                                                group='furtherFilters'
                                                                                filters={filters}
                                                                                setFilters={updateFilters} key={index}/>)}
            {filters.years.map((item, index) => <OrtFilterRemoveButton item={item}
                                                                       group='years'
                                                                       filters={filters}
                                                                       setFilters={updateFilters} key={index}/>)}
        </div>
        <section className="teaserColumns--gridThree backgroundDefault padding-bottom-block">
            <div className="baukultur-map__grid teaserColumns__wrapper" ref={teaserColumnsRef}>
                {locations.map((item) => <OrtTile data={item} key={item.id} />)}
            </div>
        </section>
    </div>
}